import axios from "axios"

export const garconClient = axios.create({
  baseURL: import.meta.env.VITE_GARCON_API,
  headers: {
    "X-Inspire-Client": "crm",
    "X-Heroku-App-Name": import.meta.env.VITE_HEROKU_APP_NAME,
  },
})
